import { string, object } from 'yup';

const schema = object().shape({
  passenger: object().shape({
    name: string().required('requiredField'),
    email: string().required('requiredField').email('invalidEmailAddress'),
    phone: string().required('requiredField').matches(/^[0-9]+$/, 'onlyNumbers'),
    password: string().required('requiredField').min(6, 'minSixCharacters')
  }),
});

export default schema;